import React from 'react';
import { Link, Outlet, useLocation } from 'react-router-dom';
import { useIdentity } from './IdentityContext';
import { ConfirmProvider } from './ConfirmContext';
import { ToastProvider } from './ToastContext';
import { GOLD, GOLD_LT, CREAM, INK } from '../theme';

const tabStyle = (active) => ({
  fontSize: 12,
  letterSpacing: '.12em',
  textTransform: 'uppercase',
  color: active ? INK : GOLD_LT,
  background: active ? GOLD_LT : 'none',
  border: `1px solid ${GOLD_LT}`,
  padding: '8px 16px',
  textDecoration: 'none',
});

export default function AdminLayout() {
  const { user, logout } = useIdentity();
  const { pathname } = useLocation();
  const onCategories = pathname.startsWith('/admin/categories');

  return (
    <ToastProvider>
      <ConfirmProvider>
        <div style={{ fontFamily: "'Cormorant Garamond', serif", background: INK, color: CREAM, minHeight: '100vh' }}>
          <nav style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '18px clamp(20px,4vw,50px)', borderBottom: '1px solid rgba(201,162,75,.2)', flexWrap: 'wrap', gap: 12 }}>
            <Link to="/admin" style={{ fontFamily: "'Bodoni Moda', serif", fontWeight: 700, fontSize: 20, color: CREAM, textDecoration: 'none' }}>IJ Couture — Admin</Link>
            <div style={{ display: 'flex', alignItems: 'center', gap: 24 }}>
              {user && <span style={{ fontSize: 13, color: 'rgba(239,228,210,.55)' }}>{user.email}</span>}
              <Link to="/" style={{ fontSize: 13, letterSpacing: '.14em', textTransform: 'uppercase', color: GOLD_LT, textDecoration: 'none' }}>View live site ↗</Link>
              <button onClick={logout} style={{ fontSize: 13, letterSpacing: '.14em', textTransform: 'uppercase', background: 'none', border: `1px solid ${GOLD}`, color: GOLD, padding: '8px 16px', cursor: 'pointer' }}>Log out</button>
            </div>
          </nav>
          <div style={{ display: 'flex', gap: 10, padding: '14px clamp(20px,4vw,50px) 0' }}>
            <Link to="/admin" style={tabStyle(!onCategories)}>Selected Silhouettes</Link>
            <Link to="/admin/categories" style={tabStyle(onCategories)}>Categories</Link>
          </div>
          <main style={{ padding: 'clamp(24px,4vh,40px) clamp(20px,4vw,50px)' }}>
            <Outlet />
          </main>
        </div>
      </ConfirmProvider>
    </ToastProvider>
  );
}
